import React, { useEffect, useRef, useState } from "react";
import { TranslationProvider, useTranslation } from "../../shared/contexts/TranslationContext";
import { LanguageToggle } from "../../shared/components/LanguageToggle";
import { AdminLink } from "../../shared/components/AdminLink";
import { DeckNavigation } from "../../shared/components/DeckNavigation";
import { Slide1 } from "./components/Slide1";
import { Slide2 } from "./components/Slide2";
import { Slide3 } from "./components/Slide3";
import { Slide4 } from "./components/Slide4";
import { Slide5 } from "./components/Slide5";
import { Slide6 } from "./components/Slide6";
import { Slide7 } from "./components/Slide7";
import { Slide8 } from "./components/Slide8";
import { Slide9 } from "./components/Slide9";
import { Slide10 } from "./components/Slide10";
import { Slide11 } from "./components/Slide11";
import { Slide12 } from "./components/Slide12";
import { Slide13 } from "./components/Slide13";
import { Slide14 } from "./components/Slide14";
import "./Emissor.css";

const TOTAL = 14; // Finalized for all slides

// Moved lang state up to wrap with TranslationProvider

export function EmissorDeckInner({ lang, setLang }) {
  const [active, setActive] = useState(0);
  const deckRef = useRef(null);
  
  const { translations } = useTranslation();
  // Safe fallback if translations are not yet loaded
  const t = translations && translations.s1 ? translations : { s1: {}, s2: {}, s3: {}, s4: {}, s5: {}, s6: {}, s7: {}, s8: {}, s9: {}, s10: {}, s11: {}, s12: {}, s13: {}, s14: {} };

  useEffect(() => {
    localStorage.setItem("emissor_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const onActive = (idx) => setActive(idx);

  const jumpTo = (idx) => {
    const el = deckRef.current?.querySelector(`[data-slide-index="${idx}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowDown" || e.key === "PageDown") {
        e.preventDefault();
        jumpTo(Math.min(TOTAL - 1, active + 1));
      } else if (e.key === "ArrowUp" || e.key === "PageUp") {
        e.preventDefault();
        jumpTo(Math.max(0, active - 1));
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <div className="App relative theme-emissor">
      <LanguageToggle lang={lang} setLang={setLang} />
      <AdminLink />

      <DeckNavigation count={TOTAL} active={active} onJump={jumpTo} variant="bars" />

      <main
        ref={deckRef}
        className="deck no-scrollbar"
        data-testid="emissor-presentation-deck"
      >
        <Slide1 t={t.s1} total={TOTAL} onActive={onActive} />
        <Slide2 t={t.s2} total={TOTAL} onActive={onActive} />
        <Slide3 t={t.s3} total={TOTAL} onActive={onActive} />
        <Slide4 t={t.s4} total={TOTAL} onActive={onActive} />
        <Slide5 t={t.s5} total={TOTAL} onActive={onActive} />
        <Slide6 t={t.s6} total={TOTAL} onActive={onActive} />
        <Slide7 t={t.s7} total={TOTAL} onActive={onActive} />
        <Slide8 t={t.s8} total={TOTAL} onActive={onActive} />
        <Slide9 t={t.s9} total={TOTAL} onActive={onActive} />
        <Slide10 t={t.s10} total={TOTAL} onActive={onActive} />
        <Slide11 t={t.s11} total={TOTAL} onActive={onActive} />
        <Slide12 t={t.s12} total={TOTAL} onActive={onActive} />
        <Slide13 t={t.s13} total={TOTAL} onActive={onActive} />
        <Slide14 t={t.s14} total={TOTAL} onActive={onActive} />
      </main>
    </div>
  );
}

export function EmissorDeck() {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("emissor_lang");
      if (stored === "pt" || stored === "en" || stored === "es") return stored;
      const nav = (navigator.language || "en").toLowerCase();
      if (nav.startsWith("es")) return "es";
      return nav.startsWith("pt") ? "pt" : "en";
    }
    return "en";
  });

  return (
    <TranslationProvider deck="emissor" lang={lang}>
      <EmissorDeckInner lang={lang} setLang={setLang} />
    </TranslationProvider>
  );
}

